import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Toggle } from "components/Form/components/Toggle/Toggle";

export const ToggleFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Toggle
                value={input.value}
                identifier={input.name}
                input={input}
                attributes={fieldAttr}
                onChange={input.onChange}
                options={fieldProps.options}
            />
        </Input>
    );
};
